import React, { useCallback, useEffect, useMemo, useState } from 'react'
import TasksAddTaskPopup from '../tasks/_TasksAddTaskPopup'
import { SimulatorModel } from '../models/SimulatorModel';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { TreatmentModel } from '../models/superbit-api-models';
import moment from 'moment';
import { setLoadTasks, setPopUpTreatmentModel, setTask, setTypeTreatmentsAction } from './../app-context/tasksSlice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app-context/store';
import { setLeadIdForTreatment, setLeadTreatmentPopUp, setLeadTreatmentType } from '../app-context/leadsSlice';
import { setTaskFileFromDocument } from '../app-context/filesSlice';

interface Props {
    customerId?: string;
    showPopUpMessage?: (message: string) => void;
    ClosePopup?: Function;
}


const ClientAddTaskPopup = (props: Props) => {

    const dispatch = useDispatch();
    const task = useSelector((state: RootState) => state.tasks.task);


    const [selectedAssigment, setSelectedAssigment] = useState<any | null>(null)
    const [showAddTreatmentPopUp, setShowAddTreatmentPopup] = useState<boolean>(false);
    const [assigmentStatuses, setAssignmentStatuses] = useState<any[]>([]);
    const [popupMessageContent, setPopupMessageContent] = useState<string | null>(null)
    const [popupMessageTitle, setPopupMessageTitle] = useState<string | undefined>(undefined);
    const customerCardModel: CustomerCardModel = new CustomerCardModel();
    
    
    const [agents, setAgents] = useState<any[]>([])
    
    const [usersList, setUsersList] = useState<any[]>([]);


    const simulatorModel: SimulatorModel = new SimulatorModel();
    const leadIdForTreatment = useSelector((state: RootState) => state.leads.leadIdForTreatment);

    const taskFileFromDocument = useSelector((state: RootState) => state.files.taskFileFromDocument);

    useEffect(() => {
        console.log('useEffect-ClientAddTaskPopup')
        var agentsData: any[] = [];
        let agentsDataStorage = localStorage.getItem('agents');
        if (agentsDataStorage) {
            agentsData = JSON.parse(agentsDataStorage);
            setAgents(agentsData);
        } else {
            fetchAgents();
        }

        const allCustomersStorage = sessionStorage.getItem('allCustomers');
        // const allCustomersStorage = localStorage.getItem('allCustomers');
        if (!allCustomersStorage) {
            // need to check with sara
            fetchAlllCustomers();
            //get all clients list for the create new assigment
        } else {
            
        }

        let handlersList: any[] = [];
        const handlersListStorage = localStorage.getItem('usersList');
        if (handlersListStorage) {
            handlersList = JSON.parse(handlersListStorage);
            const activeHandlerList = handlersList.filter((h: any) => h.status == 0
            // && (h.roleId == "4a0a7e1b-7e16-4134-b8b7-de6ef7ad2aec" || h.roleId == "e026af6f-52f0-40b6-b12f-94c546da1725"
            //     || h.branchId == "f65ba4e2-8fae-49da-b351-e288a9459f21" || h.branchId == "3b729183-d7a4-49a6-911e-35b63eb0c438")
            );
            setUsersList(activeHandlerList.map((u: any, i: number) => {
                return {
                    value: u.id,
                    label: u.fullName
                }
            }));
        } else {
            setUsersList([]);
        }

        let assigmentStatusesData: any[] = [];
        const assignmentStatusesStorage = localStorage.getItem('AssignmentStatuses');

        if (assignmentStatusesStorage) {
            assigmentStatusesData = JSON.parse(assignmentStatusesStorage);
            if (assigmentStatusesData.length > 0) {
                console.log('assignmentStatusesStorage in', assignmentStatusesStorage)
                setAssignmentStatuses(assigmentStatusesData.map((s: any) => {
                    return {
                        label: s.name,
                        value: s.id
                    }
                }))
            } else {
                fetchAssigmentStatuses();
            }
        } else {
            fetchAssigmentStatuses();
        }


        if (task) {
            editTask(task.id);
        } else {
            editTask();
        }

    }, [])

    const taskId = useMemo(() => task?.id, [task]);


    const fetchAssigmentStatuses = async () => {
        const assigmentStatusesData = await customerCardModel.getAssignmentStatuses();
        console.log('assigmentStatusesData', assigmentStatusesData)
        const assigmentStatuseslist = assigmentStatusesData.map((s: any) => {
            return {
                label: s.name,
                value: s.id
            }
        })
        setAssignmentStatuses(assigmentStatuseslist)

        localStorage.setItem('AssignmentStatuses', JSON.stringify(assigmentStatusesData));
    }

    const fetchAlllCustomers = async () => {
        const customers = await simulatorModel.customerGetAll();
        let allCustomers: any[] = [];
        allCustomers = customers.map((u: any, i: number) => {
            return {
                value: u.id,
              label: u.fullName,
              identifier:u.identifier
            }
        })
        sessionStorage.setItem('allCustomers', JSON.stringify(allCustomers));
        // localStorage.setItem('allCustomers', JSON.stringify(allCustomers));
    }



    const fetchAgents = async () => {
        const agentsData = await simulatorModel.getCustomerCardAgents();
        localStorage.setItem('agents', JSON.stringify(agentsData));
        setAgents(agentsData);
    }

    const editTask = useCallback(async (id?: string) => {
        console.log('editTask id', id, props.customerId)
        if (!id) {
            if (props.customerId) {
                if(leadIdForTreatment && leadIdForTreatment.length > 0){
                    let data = await customerCardModel.treatmentsForUpsert({leadId:leadIdForTreatment, treatmentType: 1});
                    if(taskFileFromDocument){
                        data.treatmentDocuments = [{id:taskFileFromDocument.id, filePath: taskFileFromDocument.filePath}];
                    }
                    setSelectedAssigment(data);
                } else {
                    let data = await customerCardModel.treatmentsForUpsert({customerId:props.customerId, treatmentType: 1});
                    if(taskFileFromDocument){
                        data.treatmentDocuments = [{id:taskFileFromDocument.id, filePath: taskFileFromDocument.filePath}];
                    }
                    setSelectedAssigment(data);
                }
                dispatch(setTaskFileFromDocument(null));
            } else {
                setSelectedAssigment({
                    "id": null,
                    "createdDate": null,
                    "eventDate": null,
                    "alertDate": null,
                    "treatmentType": 0,
                    "topic": "",
                    "note": "2",
                    "filePath": null,
                    "customerId": null,
                    "customer": null,
                    "from": "",
                    "to": "",
                    "cc": "",
                    "bcc": "",
                    "messageId": null,
                    "assignmentStatus": null,
                    "assignmentStatusId": null,
                    "policyRelatedId": null,
                    "policyRelated": null,
                    "sueRelatedId": null,
                    "sueRelated": null,
                    "leadRelatedId": null,
                    "leadRelated": null,
                    "offerRelatedId": null,
                    "offerRelated": null,
                    "relationEntitiesModel": null,
                    "agentId": null,
                    "agent": null,
                    "handlerId": null,
                    "handler": null,
                    "userId": null,
                    "user": null,
                    "startDate": null,
                    "endDate": null,
                    "fileAttachment": null,
                    "customersIds": null,
                    "leadsIds": null,
                    "companyId": null,
                    "company": null,
                    "priority": null,
                    "treatmentOutcome": null,
                    "emailDeliveryType": null,
                    "address": null,
                    "smsFrom": null,
                    "smsTo": null,
                    "smsMessage": null,
                    "smsPhone": null,
                    "smsSenderId": null,
                    "faxPhone": null,
                    "sentByFax": null,
                    "faxBy": null,
                    "faxInHonorOf": null,
                    "statusChangeEmail": null,
                    "statusChangeSms": null,
                    "location": null,
                    "includeLogo": false,
                    "emailBody": "",
                    // "emailBody": "KYUSHU PLUS 4X2 (1987) היברידי רגיל פנאי-שטח;;;<p><span style=\"font-size:16px\"><strong><u>ביטוח מסוג מקיף כולל כיסוי תאונה וגניבה </u></strong></span></p>\r\n\r\n<p><span style=\"font-size:16px\"><u>הביטוח כולל:</u></span></p>\r\n\r\n<ul dir=\"rtl\">\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData3</span></span></li>\r\n\t<li><span style=\"font-size:16px\">התחייבות לתיקון בחלפים מקוריים במוסך מורשה לקסוס.</span></li>\r\n\t<li><span style=\"font-size:16px\">גרירה ושרותי דרך 24 שעות ביממה- ממסי בטלפון 5202*. (כולל החלפת גלגל, גרירה מכביש 6 ומחניונים)</span></li>\r\n\t<li><span style=\"font-size:16px\">החזר הוצאות נסיעה ממקום התאונה עד 250 שח , במידה והרכב אינו במצב נסיעה.</span></li>\r\n\t<li><span style=\"font-size:16px\">כיסוי שבר שמשות סטנדרטי (לא מקורי) ללא השתתפות עצמית</span></li>\r\n\t<li><span style=\"font-size:16px\">רכב חליפי לקסוס* : לנהגים מגיל 24 מעל שנה ותק נהיגה :&nbsp;בתאונה - רכב חליפי במוסך הסדר לקסוס &nbsp;מפתח תמורת מפתח.&nbsp;בגניבה או טוטאלוסט -30 יום או עד קבלת תשלום מחברת הביטוח (המוקדם מביניהם)</span></li>\r\n\t<li><span style=\"font-size:16px\">גבול אחריות לפגיעה בצד ג&#39; 1,500,000 ₪</span></li>\r\n\t<li><span style=\"font-size:16px\">כינון אוטומט במוסך הסדר - ללא תוספת פרמיה.</span></li>\r\n\t<li><span style=\"font-size:16px\">הרכב יחשב לאובדן כללי בנזק מעל 50% בלבד.</span></li>\r\n\t<li><span style=\"font-size:16px\">השתתפות עצמית במוסכי הסדר לקסוס :&nbsp;לרכב בשווי עד 350000 שח &nbsp;1390 ₪ , לנהגים עד גיל 21 &nbsp;)לא חדשים) 2092 ש&quot;ח, לנהגים מגיל 17 או לנהגים חדשים 2794 ₪ &#39;&nbsp;&nbsp;לרכב בשווי מעל 350000 שח : 2000 ₪ , &nbsp; &nbsp; לנהגים 17+ או נהגים חדשים 3000 ₪ .</span></li>\r\n\t<li dir=\"RTL\" style=\"text-align:right\"><span style=\"font-size:16px\"><span style=\"font-family:&quot;Times New Roman&quot;,&quot;serif&quot;\"><span style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\">השתתפות עצמית בירידת ערך 1.5%</span><span dir=\"LTR\" style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\">.</span><span style=\"font-family:&quot;Arial&quot;,&quot;sans-serif&quot;\"> ברכבים בשווי מעל 350000 שח- השתתפות עצמית בירידת ערך 5%.</span></span></span></li>\r\n\t<li><span style=\"font-size:16px\">הגנה משפטית עד 50,000 ₪. ה&quot;ע 200 ₪</span></li>\r\n\t<li><span style=\"font-size:16px\">ביטוח תוספות ואבזור ברכב עד 10,000 ₪ ללא תוספת פרמיה בכפוף להצגת חשבונית בגין האביזרים טרם עריכת הביטוח .</span></li>\r\n\t<li><span style=\"font-size:16px\">שירות VIP ללקוחות הקולקטיב 24 שעות ביממה בטלפון 8099*.</span></li>\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData1</span></span></li>\r\n\t<li><span style=\"font-size:16px\"><span style=\"font-family:Arial,Helvetica,sans-serif\">DynamicData2</span></span></li>\r\n</ul>\r\n\r\n<p dir=\"RTL\"><span style=\"font-size:16px\">*רכב חליפי לקסוס או לחילופין רכב מנהלים&nbsp;על בסיס&nbsp;&nbsp;זמינות המשכיר.</span></p>\r\n\r\n<p>&nbsp;</p>\r\n;;;<p dir=\"RTL\"><span style=\"font-size:14px\"><strong><u>הביטוח מותנה וכפוף</u></strong><strong><u>:</u></strong></span></p>\r\n\r\n<ul>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">באישור העדר תביעות ביטוח מקיף 3 שנים אחרונות &ndash; יש להציג אישור תוך 7 ימים.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">אישור בדיקת מיגון הנדרש ע&quot;י חברת הביטוח.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">כל הכיסויים בכפוף לתנאי הפוליסה ולכתבי השירות הרלוונטיים.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">את הביטוח מקיף ניתן לחלק ב-4 תש&#39; ללא ריבית וחובה ב-12 תש&#39; ללא ריבית.</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">חלק מהכיסויים נמכרים ללא מעורבות חב&#39; הביטוח והנם באחריות מלאה של נותני השירות .</span></li>\r\n\t<li dir=\"RTL\"><span style=\"font-size:14px\">ט.ל.ח</span></li>\r\n</ul>\r\n",
                    "includeCustomerInfo": false,
                    "isFullDay": false,
                    "forTreatmentById": null,
                    "forTreatmentBy": null,
                    "belongsToId": null,
                    "belongsTo": null,
                    "employer": null,
                    "employerId": null,
                    "riderId": null,
                    "rider": null,
                    "status": null,
                    "assignmentStatusType": 0,
                    "whatsAppMessageId": null,
                    "treatmentActivities": [],
                    "treatmentTypeIcon": "fa-mobile-alt",
                    "upsertActionName": "UpsertSmsTreatment",
                    "FileAttachments": [],
                    "seen": false,
                    "treatmentDocuments": null,
                })
            }
        } else {
            const data = await customerCardModel.getAssignment(id);
            await customerCardModel.setAssignmentSeen(id);
            
            setSelectedAssigment(data);
        }
        setShowAddTreatmentPopup(true)
    },[props.customerId, leadIdForTreatment, taskFileFromDocument, customerCardModel])


    useEffect(() => {

        if (task && taskId) {
            editTask(taskId);
        }
    }, [task, editTask])

    const showHideAddTreatmentPopup = (show: boolean) => {
        setShowAddTreatmentPopup(show);

        if( props.ClosePopup) {
            props.ClosePopup();
        }
        if (!show) {
            dispatch(setTask(null));
            dispatch(setPopUpTreatmentModel({
                show: false,
                type: 0
            }));
            dispatch(setTypeTreatmentsAction('new'));
            dispatch(setLeadTreatmentPopUp(false));
            dispatch(setLeadIdForTreatment(""));
            dispatch(setLeadTreatmentType(0));
        }
    }


    const onSaveTask = async (data: any) => {
        if (data.endDate) {
            if (typeof (data.endDate) !== 'object') {
                data.endDate = new Date(data.endDate);
            }
        }
        const d = await customerCardModel.upsertAssignment(data);
        showHideAddTreatmentPopup(false);


        // getTreatments();
        if (data.id === null || data.id === '00000000-0000-0000-0000-000000000000') {
            dispatch(setLoadTasks(true));
            setPopupMessageContent('המשימה נוצרה בהצלחה');
            setPopupMessageTitle('יצירת משימה');
            if(props.showPopUpMessage){
                props.showPopUpMessage('טיפול שוטף מסוג משימה נוצר בהצלחה');
            }
        } else {
            dispatch(setLoadTasks(true));
            setPopupMessageContent('המשימה עודכנה בהצלחה');
            setPopupMessageTitle('עדכון משימה');
            if(props.showPopUpMessage){
                props.showPopUpMessage('טיפול שוטף מסוג משימה עודכן בהצלחה');
            }

        }
        return d;
    }


    return (
        <div>

            {showAddTreatmentPopUp && selectedAssigment && assigmentStatuses && 
                <>
                    <TasksAddTaskPopup
                        ShowHidePopup={showHideAddTreatmentPopup}
                        type={1}
                        dataToEdit={selectedAssigment}
                        statuses={assigmentStatuses}
                        onSave={onSaveTask}
                        ClosePopup={() => showHideAddTreatmentPopup(false)}
                        usersList={usersList}
                        customerId={props.customerId}
                    />
                </>
            }

        </div>
    )
}

export default ClientAddTaskPopup